import { InfoObject, WeatherData } from '../../../Components/AxCalendar/AxCalendar';
import { AxInit, ModuleName } from "../../../Lib/AxSystem/AxInit";
import { CalendarDataInit, SubCCalendar } from '../Abstraction/SubCCalendar';

@ModuleName("AxPackSelectionCalendar")
export class AxPackSelectionCalendar extends SubCCalendar implements AxInit {
    private ProjNr: number;
    private TariffSheetNr: number;
    private PackageNr: number;
    private PackageProducts: any;

    private Lang: string;

    constructor() { super(); }

    AxInit(initData: CalendarDataTicket) {
        this.ProjNr = initData.ProjNr;
        this.TariffSheetNr = initData.TariffSheetNr;
        this.PackageNr = initData.PackageNr;
        this.PackageProducts = initData.PackageProducts;

        this.Lang = initData.Lang;

        this.Init(initData);

        this.ProductSelection.SubmitSubject.subscribe(x => {
            $('.prod_selection__form').submit();
        });
    };

    LoadTickets(month: number, year: number) {
        let that = this;
        this.LoadingTickets = true;

        AxessViewer.ajaxRequest('/api/TicketsV4TimeSlotApi/GetReservationTimeSlotsForCalendar', {
            'ProjNr': this.ProjNr,
            'ProductGroupIdentifier': this.TariffSheetNr,
            'Id': this.PackageNr,
            'Month': month,
            'Year': year,
            'CiUppercase': this.Lang,
            'SubTypeIdentifiers': this.PackageProducts,
            'Type': 1
        }, (resp) => {
            for (let i = 0; i < resp.length; i++) {
                if (resp[i].TimeSlotInfo != null && resp[i].TimeSlotInfo.length > 0) {
                    let weatherData: WeatherData = null;

                    if (resp[i].WeatherData != null) {
                        weatherData = {
                            classNo: resp[i].WeatherData.ClassNo,
                            minTemp: resp[i].WeatherData.MinTemp,
                            maxTemp: resp[i].WeatherData.MaxTemp
                        };
                    }

                    let infoObject: InfoObject = {
                        Date: resp[i].ValidFrom,
                        Price: resp[i].Tariff,
                        AdditionalCellClass: '',
                        OnClick: that.ActivateDaySub,
                        ParentScope: that,
                        ActiveClass: 'axc__row_inner--active',
                        Currency: this.Currency,
                        WeatherData: weatherData
                    };
                    that.Calendar.addInfo(infoObject);

                    that.ProductList.push({
                        Date: resp[i].ValidFrom,
                        Products: resp[i].Products,
                        TimeSlotInfo: resp[i].TimeSlotInfo
                    });
                } else {
                    let infoObject: InfoObject = { Date: resp[i].ValidFrom, Price: 0, ParentScope: that };
                    that.Calendar.addInfo(infoObject);
                    that.Calendar.addCellClass(resp[i].ValidFrom, 'allotment__notificiation--off');
                }
            }
            that.UpdatePrice(true);
            that.LoadingTickets = false;

            if (that.NextLoadRequested) {
                that.NextLoadRequested = false;
                that.Calendar.next(true);
            }
        }, {
            type: 'POST'
        });
    }

}

export interface CalendarDataTicket extends CalendarDataInit {
    TariffSheetNr: number;
    PackageNr: number;
    PackageProducts: any;
}
